module.exports = __webpack_public_path__ + "img/vizualPR_en.2a0182b6.jpg";